<template>
  <div>
    <router-link
      v-if="canView || canEdit"
      :to="currentRoute + '/' + getEntityId(item) + '/detail'"
    >
      <md-button class="md-just-icon md-success md-simple table-action ">
        <md-tooltip md-direction="top">{{ $t("common.edit") }} </md-tooltip>
        <md-icon v-if="canEdit">edit</md-icon>
        <md-icon v-if="canView && !canEdit">visibility</md-icon>
      </md-button>
    </router-link>
    <md-button
      v-if="canDelete"
      class="md-just-icon md-danger md-simple table-action "
      @click.native="triggerConfirmDelete"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }} </md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { GraduationCategory } from "@/constants/Permissions";

export default {
  props: ["item"],
  data() {
    return {
      status: this.item.status,
      path: service_paths.graduation_categories,
      GraduationCategory
    };
  },
  computed: {
    canEdit() {
      return this.$can(
        GraduationCategory.actions.edit,
        GraduationCategory.subject
      );
    },
    canView() {
      return this.$can(
        GraduationCategory.actions.view,
        GraduationCategory.subject
      );
    },
    canDelete() {
      return this.$can(
        GraduationCategory.actions.delete,
        GraduationCategory.subject
      );
    },
    currentRoute() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    }
  },
  inject: ["confirmDelete"],
  methods: {
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    },
    getEntityId(item) {
      return item.id || item._id;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
